import api from '@/services/api/api'

class ThemesService {
  getAllThemes () {
    return api.get('theme').then(result => {
      return result.data
    })
  }

  saveTheme (theme) {
    return api.post('theme', theme)
  }

  removeTheme (theme) {
    return api.delete('theme/' + theme.id)
  }
}

export default new ThemesService()



// WEBPACK FOOTER //
// ./src/services/codebooks/ThemesService.js